import React from 'react';
import PropTypes from 'prop-types';

// Components
import Search from '../Search';
import SearchResults from '../Search/SearchResults';
import EventSessionCard from '@molecules/EventSessionCard';
import EventSessionListItem from '@molecules/EventSessionListItem';
import LoadingArea from '@molecules/LoadingArea';

// Helpers
import useSavedSessionFilters from '../../../hooks/algoliaFilters/useSavedSessionFilters';
import { SAVED_SESSIONS_QUERY } from '@general/graphql/session.graph';
import { mapSearchSessionToProps } from '@general/transforms/session.transform';

const SearchSavedSessions = ({
    event,
    activeDay,
    showSearchBox = false,
    showSearchOptions = false,
    hitsPerPage = 1000,
}) => {
    const { filters } = useSavedSessionFilters({ eventCode: event.event_code, activeDay });

    if (filters.length === 0) {
        return <LoadingArea />;
    }

    return (
        <Search
            index="everything_session_start_time_asc_virtual"
            defaultViewType="list"
            displaySearchBox={showSearchBox}
            displaySearchOptions={showSearchOptions}
            hitsPerPage={hitsPerPage}
            filters={filters}
        >
            <SearchResults
                cardComponent={EventSessionCard}
                index="everything_session_start_time_asc_virtual"
                listItemComponent={EventSessionListItem}
                query={SAVED_SESSIONS_QUERY}
                resultsPerRow={1}
                transformFunc={mapSearchSessionToProps}
                typePlural="sessions"
            />
        </Search>
    );
};

SearchSavedSessions.propTypes = {
    event: PropTypes.shape({
        event_code: PropTypes.string.isRequired,
    }),
    activeDay: PropTypes.instanceOf(Date),
    showSearchBox: PropTypes.bool,
    showSearchOptions: PropTypes.bool,
    hitsPerPage: PropTypes.number,
};

export default SearchSavedSessions;
